import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { palette, radius, shadow, typography } from './designTokens';

// Note: header padding is intentionally fixed and decoupled from body padding,
// so callers can pass padding={0} or noPadBody to flush body content (tables,
// lists) against the card edges without losing the header padding.
const HEADER_PX = 2.5;
const HEADER_PY = 1.75;

const SectionCard = ({
  title,
  subtitle,
  actions,
  children,
  padding = 2.5,
  noPadBody = false,
  sx = {},
  bodySx = {},
}) => {
  return (
    <Box
      sx={{
        bgcolor: palette.surface,
        borderRadius: `${radius.md}px`,
        border: `1px solid ${palette.line}`,
        boxShadow: shadow.card,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {(title || actions) && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          justifyContent="space-between"
          spacing={{ xs: 1.5, sm: 2 }}
          sx={{
            px: HEADER_PX,
            py: HEADER_PY,
            borderBottom: `1px solid ${palette.line}`,
          }}
        >
          {/* minWidth: 0 lets a long subtitle wrap instead of forcing the row
              wider and squeezing the actions — a flex item with no basis
              refuses to shrink below its content, which deforms the button. */}
          <Box sx={{ minWidth: 0 }}>
            {title && <Typography sx={typography.sectionTitle}>{title}</Typography>}
            {subtitle && (
              <Typography sx={{ ...typography.caption, mt: 0.25 }}>{subtitle}</Typography>
            )}
          </Box>
          {actions && (
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              flexWrap="wrap"
              useFlexGap
              sx={{ flexShrink: 0, justifyContent: { xs: 'flex-start', sm: 'flex-end' } }}
            >
              {actions}
            </Stack>
          )}
        </Stack>
      )}
      <Box sx={{ p: noPadBody ? 0 : padding, ...bodySx }}>{children}</Box>
    </Box>
  );
};

export default SectionCard;
